import React from 'react';

import { mediaBreakpoints, Row, Rows, Span, Text } from '~/src/dash/publicaUI';
import { useBaseState } from '~/src/dash/views/base/contexts';

export const BrowserSizeTracker = () => {
  const { totalWidth, totalHeight, mediaSize } = useBaseState();

  const min = mediaBreakpoints[mediaSize][0];
  const max = mediaBreakpoints[mediaSize][1];

  return (
    <Rows>
      <Row>
        <Text subheader>Browser Dimensions</Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Browser Width:</Span> {totalWidth}
        </Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Browser Height:</Span> {totalHeight}
        </Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Media Size:</Span>{' '}
          <Span highlighted bold>
            '{mediaSize}'
          </Span>
        </Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Breakpoint Range:</Span> {min}px - {max}px
        </Text>
      </Row>
    </Rows>
  );
};
